import React from "react";

interface HighlightTextProps {
    text: string;
    highlight: string;
}

const HighlightText: React.FC<HighlightTextProps> = ({ text, highlight }) => {
    const trimmed = highlight.trim();
    if (!trimmed || !text) return <>{text}</>;

    const escaped = trimmed.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const parts = text.split(new RegExp(`(${escaped})`, "gi"));

    return (
        <>
            {parts.map((part, i) =>
                i % 2 === 1 ? (
                    <mark key={i} style={{ backgroundColor: "#fef08a", padding: 0, borderRadius: 2 }}>
                        {part}
                    </mark>
                ) : (
                    <React.Fragment key={i}>{part}</React.Fragment>
                )
            )}
        </>
    );
};

export default HighlightText;
